import React from 'react'

import { Colors, IconBadge, MediumIcon } from '@factorialco/deprecated-design-system'

import { useMemo } from 'modules/core/hooks/useMemo'

import { QuestionTypeSelector } from 'modules/questionnaires/lib/types'

type Props = {
  type: QuestionTypeSelector
}

const QuestionIcon: React.FC<Props> = ({ type }) => {
  const styles = useMemo(():
    | {
        icon: MediumIcon
        backgroundColor: Colors
        color: Colors
      }
    | undefined => {
    switch (type) {
      case 'multiple_choice':
        return {
          icon: 'check',
          backgroundColor: 'viridian200',
          color: 'viridian1200',
        }
      case 'single_choice':
        return {
          icon: 'circle',
          backgroundColor: 'viridian200',
          color: 'viridian1200',
        }
      case 'text':
        return {
          icon: 'text-size',
          backgroundColor: 'tangerine200',
          color: 'tangerine1000',
        }
      case 'rating':
        return {
          icon: 'star',
          backgroundColor: 'champagne200',
          color: 'champagne1000',
        }
      case 'number':
        return {
          icon: 'numbers',
          backgroundColor: 'malibu200',
          color: 'malibu1000',
        }
      default:
        return undefined
    }
  }, [type])

  if (styles === undefined) {
    return null
  }

  return (
    <IconBadge
      icon={styles.icon}
      iconColor={styles.color}
      color={styles.backgroundColor}
      size="s24"
    />
  )
}

export default QuestionIcon
